import { Component } from 'react';
import PropTypes from "prop-types";
import { Link, Route, Routes } from "react-router-dom";

// Helpers.
import Helmet from "react-helmet";

// Constants.
import { DATA_INITIALISING, DATA_LOADED, DATA_LOADING } from "../../../../component/Constants";

// APis
import IntegrationsApi from "../../../../api/Integrations";

//Types
import IntegrationType from "../../../../types/integration/IntegrationType";

// Components.
import Breadcrumb from "../../../../container/breadcrumb";
import HeaderActions from "../../../../container/header_actions";
import ConditionalRender from "../../../../helpers/ConditionalRender";

// import Detail from './Detail';
import List from "./List";
import Detail from "./Detail";


interface SlackProps {
    toggleMenu: Function,
    applyPeriod: Function,
    isAdmin: boolean
}

interface SlackState {
    loading: number,
    slack: IntegrationType[],
}

const initialState = {
    loading: DATA_INITIALISING,
    slack: []
}

class Slack extends Component<SlackProps, SlackState> {
    static propTypes: { toggleMenu: PropTypes.Validator<(...args: any[]) => any>, applyPeriod: PropTypes.Validator<(...args: any[]) => any>, isAdmin: PropTypes.Validator<boolean>; };

    constructor(props: SlackProps) {
        super(props);

        this.state = initialState;
    };

    async getData() {
        const slack = await IntegrationsApi.getIntegrationData('slack');
        this.setState({
            loading: DATA_LOADED,
            slack
        });
    }

    componentDidMount() {
        const { loading } = this.state;

        if (loading === DATA_INITIALISING) {

            this.setState({
                loading: DATA_LOADING
            });

            this.getData();
        }
    }

    /* Action Methods */
    refresh = () => {

        this.setState({
            loading: DATA_LOADING
        });

        this.getData();
    }

    render() {
        const { loading, slack } = this.state;

        return (
            <div id="content">
                <Helmet>
                    <title>Slack - Settings - DBmarlin</title>
                    <meta name="description" content="Manage Slack"/>
                </Helmet>

                <div id="top-header-wrapper" className="row row-cols-2">
                    <Breadcrumb heading="Slack">
                        <Link to="/admin">Settings</Link>
                        <Link to="/admin/integrations">Integrations</Link>
                        <span>Slack</span>
                    </Breadcrumb>
                    <HeaderActions toggleMenu={this.props.toggleMenu} refresh={this.refresh}
                                   applyPeriod={this.props.applyPeriod}/>
                </div>

                <div className="loader">
                    <ConditionalRender if={false}>
                        <div className="bar"/>
                    </ConditionalRender>
                </div>

                <div className="row row-cols-1">
                    <Routes>
                        <Route path="/:actionId" element={<Detail refresh={this.refresh} slack={slack} isAdmin={this.props.isAdmin} />}/>
                        <Route path="/" element={<List loading={loading} slack={slack} refresh={this.refresh} isAdmin={this.props.isAdmin}/>}/>
                    </Routes>
                </div>
            </div>
        )
    }
}

Slack.propTypes = {
    toggleMenu: PropTypes.func.isRequired,
    applyPeriod: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired
};

export default Slack;
